export enum LocationType {
    Country = 0,
    County = 1,
    Municipality = 2,
    Region = 3,
}